import {Field, FieldProps, Form, Formik, FormikProps} from 'formik';
import React, {forwardRef, memo} from 'react';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';

import {Patient} from '../../interfaces/entities/patient.interface';
import {MultiLinesField} from './shared/multi-lines-field.component';

type PatientPreferredActivities = Pick<Patient, 'preferredActivities'>;

interface PatientPreferredActivitiesFormProps extends PatientPreferredActivities {
  onChange: (data: PatientPreferredActivities) => void;
}

const MIN_ROWS = 5;

function PatientPreferredActivitiesFormBase(
  {onChange, ...props}: PatientPreferredActivitiesFormProps,
  ref: React.Ref<FormikProps<Patient>>
) {
  const {t} = useTranslation();

  return (
    <Formik<PatientPreferredActivities>
      initialValues={props || {}}
      onSubmit={onChange}
      innerRef={ref as React.Ref<FormikProps<PatientPreferredActivities>>}
      validationSchema={Yup.object<Record<keyof PatientPreferredActivities, Yup.AnySchema>>().shape({
        preferredActivities: Yup.string().nullable().optional(),
      })}
    >
      {() => (
        <Form>
          <Field name="preferredActivities">
            {(props: FieldProps) => {
              return (
                <MultiLinesField
                  {...props}
                  label={t('patient-edit-preferred-activities.label2')}
                  assistiveText={t('patient-edit-preferred-activities.assistive')}
                  assistiveTextPosition="top"
                  minRows={MIN_ROWS}
                />
              );
            }}
          </Field>
        </Form>
      )}
    </Formik>
  );
}

export const PatientPreferredActivitiesForm = memo(forwardRef(PatientPreferredActivitiesFormBase));
